import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import TOOLBAR_PICTURE from '@tencent/docs-design-resources/icon/desktop/svg/print_outline_light_24.svg';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { MenuKey } from '../../schema/menu-schema/common';

export const config = {
    id: ActionType.PRINT,
    tipMsg: i18n.t('打印'),
    title: i18n.t('打印'),
    icon: TOOLBAR_PICTURE,
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.title,
    },
    {
        name: MenuKey.PRINT_HOR,
        content: config.title,
        icon: <img src={TOOLBAR_PICTURE} style={{ width: '24px', height: '24px' }} />,
    },
    {
        name: MenuKey.PRINT,
        content: config.title,
    },
];

export const TOOLBAR_CONFIGS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: config.title,
        style: {
            width: 'auto',
        },
    },
    {
        name: wrapIdForBig(config.id),
        icon: <img src={config.icon} alt={''}/>,
        text: config.title,
        style: {
        },
    },
];
